import React from 'react';
import ItemSelection from '../containers/selection';
import YearButtons from '../containers/years';
import ConvertData from '../containers/processing';
import LineGraph from '../containers/line_graph';
import { Helmet } from "react-helmet";


const HeadData = (project) =>(
  <Helmet>
    <title>{project}類月平均價格 | 農業視覺化</title>
    <meta name="description" content={`${project}類月平均價格，依農作物的年份查詢月平均，視覺化價格趨勢。`} />
  </Helmet>
);

const LoadData = (props) => {
  let data, type = '';
  switch (props.type) {
    case "vegitables": 
      data = require('../../data/vegitables.json');
      type = 'vegitables';
      return (
        <Visualization data={data} itemType={type} typeChsName="蔬菜"/>
      );

    case "fruits":
      data = require('../../data/fruits.json');
      type = 'fruits';
      return (
        <Visualization data={data} itemType={type} typeChsName="水果"/>
      );

    case "grains":
      data = require('../../data/grains.json');
      type = 'grains';
      return (
        <Visualization data={data} itemType={type} typeChsName="雜糧"/>
      );

    case "special":
      data = require('../../data/special.json');
      type = 'special';
      return (
        <Visualization data={data} itemType={type} typeChsName="特作"/>
      );
    
    case "flowers":
      data = require('../../data/flowers.json');
      type = 'flowers';
      return (
        <Visualization data={data} itemType={type} typeChsName="花卉" />
      );
    
    default:
      console.log('Failed to load data.');
  } 
};

const svgSize = [500, 500]; //** [w, h]


export default class Visualization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemSelected: '',
      unit: '',
      itemChsName: '',
      convertedData: [],
      year: '',
      yearIndex: '',
      loadingDataCondition: false
    };
    this.handleChangeItem = this.handleChangeItem.bind(this);
    this.handleConvertedData = this.handleConvertedData.bind(this); 
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleChangeItem(value) {
    if (value !== '-') {
      this.setState({
        itemSelected: value,
        unit: this.props.data[this.props.itemType][value]['unit'],
        itemChsName: this.props.data[this.props.itemType][value]['itemName'],
        loadingDataCondition: false,
        year: '',
        yearIndex: '',
        convertedData: []
      });
    }
  }

  shouldComponentUpdate(nextState) {
    if (this.state.itemSelected !== nextState.itemSelected) {
      return true;
    }
    return false;
  }

  handleConvertedData(convertedData) {
  //  console.log('selected! ');

    this.setState({
      convertedData: convertedData,
      loadingDataCondition: true,
    });
  }

  handleYearClicked(year, index) {
    this.setState({
      year: year,
      yearIndex: index
    });
  }

  render() {
  //  document.title = '農業視覺化 - ' + this.props.typeChsName + '類價格';
   // TODO window.scrollTo(0, 0);  //** */ to load top of the page

    let changedItemTo = this.state.itemChsName + this.state.unit ;

    return (
      <div id="visualization">
          { HeadData(this.props.typeChsName) }
          <div id="item-info-board">
            <ul>
              <li>{this.props.typeChsName}類</li>
              <li className={this.state.itemChsName !== '' ? 'selected' : 'unselected'}>{this.state.itemChsName !== '' ? this.state.itemChsName : '請選擇項目'}</li>
              <li className={this.state.year !== '' ? 'selected' : 'unselected'}>{this.state.year !== '' ? this.state.year + ' 年' : '請選擇年份'} </li>
              <li>{this.props.data['detail']['data']}</li>
            </ul>
          </div>
          
          <div id="graph-controller">
            <ItemSelection data={this.props.data} 
              type={this.props.itemType}
              typeChsName={this.props.typeChsName} 
              onChange={(value) => { this.handleChangeItem(value) }}
              />

            { this.state.loadingDataCondition && this.state.convertedData[0]['Name'] === changedItemTo ? 
            <YearButtons data={this.state.convertedData}
              type={this.props.itemType} 
              onChange={(year, index) => {this.handleYearClicked(year, index)}}
              itemSelected={this.state.itemSelected} 
              yearSelected={[this.state.year, this.state.yearIndex]}  
            />
            : <YearButtons data={[]} type={''} itemSelected={''} yearSelected={[this.state.year, this.state.yearIndex]} /> }
          </div>

          { this.state.convertedData.length !== 0 && this.state.convertedData[0]['Name'] === changedItemTo ? true : null } {/** TODO: 2020 14 Sep 16:24 unfinished */}
          
          { this.state.loadingDataCondition && this.state.convertedData[0]['Name'] === changedItemTo ? 
          <LineGraph data={this.state.convertedData} 
            type={this.props.itemType}
            unit={this.state.unit}
            index={this.state.yearIndex} 
            size={svgSize}
            value={this.state.itemSelected}
            itemChsName={this.state.itemChsName}
            year={this.state.year}
            dataType={this.props.data['detail']['data']}
            loadingDataCondition={this.state.loadingDataCondition}
            test={1} /> 
          :  <LineGraph data={[]} 
            type={''}
            unit={''}
            index={''} 
            size={svgSize}
            value={this.state.itemSelected}
            itemChsName={''}
            year={''}
            dataType={this.props.data['detail']['data']}
            loadingDataCondition={this.state.loadingDataCondition}
            test={2}
             /> }
          
          <ConvertData value={this.state.itemSelected}
            itemType={this.props.itemType}
            unit={this.state.unit}
            itemChsName={this.state.itemChsName}
            onChange={(convertedData) => {this.handleConvertedData(convertedData)}} /> 
      </div>
    );
  }
};

export { LoadData };


// WEBPACK FOOTER //
// ./src/components/pages/visualization.js